import React,{useEffect} from 'react';
import './ServicesPage.css';
import TopSlideSection from './TopSlideSection';
import ServicesPageSecondSection from './ServicesPageSecondSection';
import SolarServices from './SolarServices';

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className="container-fluid" id='servicespage'>
      <TopSlideSection/>
      <ServicesPageSecondSection/>
      
    </div>
  )
}

export default ServicesPage
